import { Component, Element, Host, Prop, h, Watch } from '@stencil/core';
import { SelectedAriaAttributes, TThemeColors, parseAndGetAriaAttributes } from '../../utils';
import { TLinkAriaAttribute, TLinkSize, TLinkVariant, LINK_VARIANTS } from './link-utils';
import { TIcon } from '../../svg/icons';

@Component({
  tag: 'dc-ui-link',
  styleUrl: 'dc-ui-link.scss',
  shadow: true,
})
export class DcUiLink {
  @Element() host: HTMLElement;
  @Prop() aria?: SelectedAriaAttributes<TLinkAriaAttribute>;
  @Prop() disabled?: boolean = false;
  @Prop() download?: boolean = false;
  @Prop() href: string;
  @Prop() icon?: TIcon;
  @Prop() iconSource?: string;
  @Prop() inline?: boolean = true;
  @Prop() size?: TLinkSize = 'normal';
  @Prop() target?: string = '_self';
  @Prop() variant?: TLinkVariant = 'primary';
  @Prop() underlined?: boolean = false;
  @Prop({ reflect: true }) theme?: TThemeColors = 'light';

  isComponentValid = true;

  @Watch('variant')
  validateVariant(variant: TLinkVariant) {
    if (!LINK_VARIANTS.includes(variant)) {
      this.isComponentValid = false;
      throw new Error(`Invalid variant: ${variant}`);
    }
  }

  @Watch('href')
  checkForHref() {
    if (!this.href || this.href === '') {
      this.disabled = true;
    }
  }

  componentWillLoad() {
    this.checkForHref();
    this.validateVariant(this.variant);
  }

  render() {
    const hrefAttribute = !this.disabled ? { href: this.href } : {};
    const downloadAttribute = this.download ? { download: '' } : {};
    const disabledAttribute = this.disabled ? { ariaDisabled: this.disabled, role: 'link' } : {};

    if (this.isComponentValid) {
      return (
        <Host
          class={`
            ${this.inline ? 'inline' : ''}
          `}>
          <a
            {...hrefAttribute}
            {...downloadAttribute}
            {...disabledAttribute}
            {...parseAndGetAriaAttributes(this.aria)}
            class={`
              dc-ui-link
              dc-ui-link--${this.variant}
              dc-ui-link--${this.size}
              ${this.underlined ? 'dc-ui-link--underlined' : ''}
              ${this.disabled ? 'disabled' : ''}
            `}
            target={this.target}>
            {this.icon?.length || this.iconSource?.length ? (
              <dc-ui-icon
                name={this.icon}
                source={this.iconSource}
                size={this.size === 'normal' ? 'medium' : 'tiny'}></dc-ui-icon>
            ) : null}
            <dc-ui-text
              variant={`link-${this.size}`}
              color="inherit">
              <slot />
            </dc-ui-text>
          </a>
        </Host>
      );
    }
  }
}
